/**
 * Return the weakest of a or b. false is weaker than null, null is weaker than true.
 * @param a {boolean|null}
 * @param b {boolean|null}
 * @returns {boolean|null}
 * @throws If a or b are not of type boolean or null.
 */
export default function merge(a, b) {
    switch(true) {
        case a === false || b === false:
            return false;
        case a === null || b === null:
            return null;
        case a === true && b === true:
            return true;
        default:
            throw new Error('a or b is not of type {bool|null}');
    }
}
